import { AxiosResponse } from 'axios';

import { ANALYTICS_EVENT_TYPES, AnalyticsData } from './constants/Analytics';
import api from '../../../api';

const API_URL = '/api/events/';

type ValuesOfObject<T extends Record<string, string>> = T[keyof T];

export type AnalyticsEvent = {
  analyticsData: AnalyticsData;
  eventType: ValuesOfObject<typeof ANALYTICS_EVENT_TYPES>;
  objectId?: string;
  subObjectId?: string;
  sessionEndDateTime?: string;
};

function useAnalytics(): {
  capture: (event: AnalyticsEvent, token: string) => Promise<AxiosResponse<void>>;
} {
  const capture = async (analyticsEvent: AnalyticsEvent, token: string) => {
    const headers = { Authorization: `Bearer ${token}` };

    const { analyticsData, ...event } = analyticsEvent;

    return api.post<void>(
      API_URL,
      {
        locationId: analyticsData.locationId,
        subLocationId: analyticsData.subLocationId,
        ...event,
        sessionStartDateTime: new Date().toISOString(),
      },
      { headers },
    );
  };

  return { capture };
}

export default useAnalytics;
